import React from "react";
import { Text, View, StyleSheet, Link, Image } from "@react-pdf/renderer";
import ZephyrLite from "../../../../assets/images/bcc/new-zephyr-lite.png";
import MobilePhone from "../../../../assets/images/bcc/phone.png";
import QRCode from "../../../../assets/images/bcc/qr-code.png";

const styles = StyleSheet.create({
    title: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 14,
        color: "#4E73C3",
        marginBottom: 16
    },
    paragraph: {
        color: "#000",
        lineHeight: 1.5,
        letterSpacing: -0.32
    },
});

const EighthPage = () => {

    return (
        <View style={{ display: "flex", flexDirection: "column" }} wrap={false}>
            <Text style={styles.title}>Where does the data come from?</Text>
            <Text style={{ ...styles.paragraph, fontSize: 11, marginBottom: 16 }}>Your school is part of Birmingham City Council’s Schools’ Air Quality Monitoring Programme which is educating the community on Air Quality.</Text>
            <Text style={{ ...styles.paragraph, fontSize: 11, marginBottom: 16 }}>A Zephyr® air quality monitor has been installed at the school and is now measuring air quality in real-time, hour-by-hour. </Text>
            <View style={{ display: 'flex', flexDirection: 'row', marginBottom: 32 }}>
                <View style={{ width: 294, height: 208, marginRight: 20 }}>
                    <Text style={{ ...styles.paragraph, fontSize: 11, marginBottom: 16 }}>The device measures important airborne pollutants that are hazardous to human health. Data from the Zephyr® is sent over 4G to the EarthSense®  cloud, ready to be used in this report.</Text>
                    <Text style={{ ...styles.paragraph, fontSize: 11, marginBottom: 16 }}>A cool feature about the Zephyr® is it has a coloured light, which changes colour when the Air Quality changes.</Text>
                    <Text style={{ ...styles.paragraph, fontSize: 11 }}>Zephyr® empowers everyone with accurate air quality information to help inform positive choices for your community and environment.</Text>
                </View>
                <Image style={{ width: 221, height: 208 }} src={ZephyrLite} />
            </View>
            <View style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 24, paddingRight: 24, borderRadius: 4, backgroundColor: '#F7FAFC' }}>
                <Text style={styles.title}>Where do I go to find more information?</Text>
                <View style={{ display: 'flex', flexDirection: 'row', height: 290, maxHeight: 290 }}>
                    <View style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 208, height: 290 }}>
                        <Image style={{ width: 140, height: 290 }} src={MobilePhone} />
                    </View>
                    <View style={{ width: 218, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginLeft: 16 }}>
                        <Text style={{ ...styles.paragraph, marginBottom: 24, fontSize: 12, textAlign: 'center', fontFamily: 'Helvetica-Bold', color: '#1A202C' }}>Access your latest air quality{"\n"}measurements here</Text>
                        <View style={{ marginBottom: 24, padding: 4, borderRadius: 10, backgroundColor: "#FFF" }}><Image style={{ width: 71, height: 71 }} src={QRCode} /></View>
                        <Link style={{ ...styles.paragraph, fontSize: 11, textAlign: 'center', color: '#4A5568', }} src="https://portal.earthsense.co.uk/BCCpublic">https://portal.earthsense.co.uk/{"\n"}BCCpublic</Link>
                    </View>
                </View>
            </View>
        </View >
    )
};

export default EighthPage;